import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { DialogService, FormNavigationService, MessagePlaceholders, SpinnerService } from 'dspx-core';

import { DeactivationGuard } from '../../interfaces/deactivation-guard.interface';

import { ServiceWorkerService } from '../../services/service-worker.service';
import { AppDataService } from '../../services/app-data.service';
import { HtmlHelperService } from '../../services/html-helper.service';
import { ResponseParserService } from '../../services/response-parser.service';

import { BaseCardSetComponent } from '../base-card-set-component/base-card-set.component';

@Component({ template: '' })
export abstract class BaseCardSetDetailComponent extends BaseCardSetComponent implements DeactivationGuard {

  protected isFormEditable = false;

  protected constructor(
    protected router: Router,
    protected serviceWorkerService: ServiceWorkerService,
    protected appDataService: AppDataService,
    protected spinnerService: SpinnerService,
    protected htmlHelperService: HtmlHelperService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected formNavigationService: FormNavigationService) {

    super(
      router,
      serviceWorkerService,
      appDataService,
      spinnerService,
      htmlHelperService,
      dialogService,
      responseParserService,
      formNavigationService);
  }

  protected showNotification(notificationCode: string): void {
    const data: MessagePlaceholders = null
    const isClosable = true;
    const isSticky = false;
    const durationMs = 5000;
    this.dialogService.showNotification(notificationCode, data, isClosable, isSticky, durationMs);
  }
}
